import { useState, useEffect, useCallback } from 'react';
import { prototypesApi } from '@infrastructure/api';
export function useHealthSummary() {
    const [healthSummary, setHealthSummary] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchHealthSummary = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const data = await prototypesApi.getHealthSummary();
            setHealthSummary(data);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'Failed to load health summary';
            setError(message);
        }
        finally {
            setIsLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchHealthSummary();
    }, [fetchHealthSummary]);
    return {
        healthSummary,
        isLoading,
        error,
        refetch: fetchHealthSummary,
    };
}
